import type { Nullish } from '@iheartjane/types';

/**
 * Ten national digits, for comparing numbers that may be formatted differently.
 * Null when the value is not a usable ten-digit number, so two unparseable
 * values never compare equal.
 */
export const phoneDigits = (phone: Nullish<string | number>) => {
  const digits = `${phone ?? ''}`.replace(/\D+/g, '');
  const national =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  return national.length === 10 ? national : null;
};
